import { ParkHistoryPanel } from "./ParkHistoryPanel";
import { ParkFilters, ParkHeader, ParkTable } from "./ParkOverview";
import { ParkSidePanel } from "./ParkSidePanel";
import { useEquipmentPark, useMaintenanceProcedures, useParkItemForm } from "./useEquipmentPark";
import { useParkHistory } from "./useParkHistory";

// Parc matériel : stock, locations, procédures d'entretien et révisions.
export function EquipmentPark({ serviceKey }) {
    const park = useEquipmentPark(serviceKey);
    const itemForm = useParkItemForm(park);
    const maintenance = useMaintenanceProcedures(park, itemForm.setForm);
    const history = useParkHistory(park);
    const { items, error, isParkCompact, selectedItem, saving } = park;

    return (
        <div style={{ height: "100%", overflow: "auto", background: "#F4F1EA" }}>
            <div style={{ padding: "18px", display: "flex", flexDirection: "column", gap: "14px" }}>
                <ParkHeader items={items} onAdd={itemForm.startAdd} />

                {error && (
                    <div style={{ border: "1px solid #FCA5A5", background: "#FEF2F2", color: "#991B1B", borderRadius: "8px", padding: "10px 12px", fontSize: "13px", fontWeight: 700 }}>
                        {error}
                    </div>
                )}

                <div style={{ display: "grid", gridTemplateColumns: isParkCompact ? "minmax(0, 1fr)" : "minmax(0, 1fr) minmax(360px, 430px)", gap: "14px", alignItems: "start" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "14px", minWidth: 0 }}>
                        <ParkFilters park={park} />
                        <ParkTable park={park} onEdit={itemForm.edit} />
                        {selectedItem && (
                            <ParkHistoryPanel selectedItem={selectedItem} isParkCompact={isParkCompact} saving={saving} history={history} />
                        )}
                    </div>
                    <ParkSidePanel park={park} itemForm={itemForm} maintenance={maintenance} />
                </div>
            </div>
        </div>
    );
}
